var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcaseClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6691 11.399C12.062 11.53 12.4868 11.3176 12.6178 10.9247C12.7487 10.5317 12.5364 10.107 12.1434 9.97599L11.6691 11.399ZM9.375 9.84375H8.625C8.625 10.1666 8.83157 10.4532 9.13783 10.5553L9.375 9.84375ZM10.125 6.31565C10.125 5.90144 9.78921 5.56565 9.375 5.56565C8.96079 5.56565 8.625 5.90144 8.625 6.31565H10.125ZM12.1434 9.97599L9.61217 9.13224L9.13783 10.5553L11.6691 11.399L12.1434 9.97599ZM10.125 9.84375V6.31565H8.625V9.84375H10.125ZM15.375 9C15.375 12.3137 12.6887 15 9.375 15V16.5C13.5171 16.5 16.875 13.1421 16.875 9H15.375ZM9.375 15C6.06129 15 3.375 12.3137 3.375 9H1.875C1.875 13.1421 5.23286 16.5 9.375 16.5V15ZM3.375 9C3.375 5.68629 6.06129 3 9.375 3V1.5C5.23286 1.5 1.875 4.85786 1.875 9H3.375ZM9.375 3C12.6887 3 15.375 5.68629 15.375 9H16.875C16.875 4.85786 13.5171 1.5 9.375 1.5V3Z",
    fill: "#616874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcaseClock);
export default __webpack_public_path__ + "static/media/broadcaseClock.248158404327768d18181645525db56e.svg";
export { ForwardRef as ReactComponent };